@if (producer) {
  <a class="producer-card" [routerLink]="['/', producer.organizer_page]">
    <img [src]="thumbnailUrl" [alt]="displayName" [appImgFallback]="fallbackImage" />
    <p>{{ displayName }}</p>
  </a>
} @else {
  <div class="load-element">
    <p-skeleton shape="circle" size="150px" />
    <p-skeleton height="2rem" />
  </div>
}
